// src/components/ui/WhatsAppButton.jsx

import React from "react";
import "../../assets/styles/global.css";
import { FaWhatsapp } from "react-icons/fa";

function WhatsAppButton() {
  const phone = "00963987654321";

  return (
    <a
      href={`https://wa.me/${phone}`}
      className="whatsapp-icon-btn"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp size={32} />
    </a>
  );
}

export default WhatsAppButton;
